import React, { useState, useEffect } from 'react';
// import GoogleMapComponent from './GoogleMapComponent';
import { fetchTourDetails, fetchSpecificTourDetail } from '../utils/api';
import Loader from './LoaderComponent';
// import TripAdvisorRating from './TripAdvisor/TripAdvisorComponent';
// import HotelDetailThingsToDo from './HoteDetailThingsToDoComponent';
// import { processData } from '../data/processData';
// import { Country } from '../data/countryData';
import ReadMoreLines from '../components/ReadMoreLines';

// Define TypeScript interfaces for expected props and other objects
interface HotelDetailsProps {
  slug: string;
  roomDetails?: { title: string; paragraphs: string[] }[];
  facilitiesTitle?: string;
  tourName?: string;
  mapTitle?: string;
  latitude: string;
  longitude: string;
  tourQuery: string;
  hotelId: string;
  destinationCode: string;
  //hasWhyThisResort: boolean;
  amenities: { group_name: string; amenities: string[]; non_free_amenities: string[] }[];
}

// interface Facility {
//   name: string;
//   icon: string;
// }

// interface RoomDetails {
//   facilities: Facility[];
//   photos: { url_max750: string }[];
// }

// interface HotelDetailsData {
//   data: {
//     name: string;
//     rooms: Record<string, RoomDetails>;
//     facilities_block: {
//       facilities: Facility[];
//     }
//   }
// }

interface TourProduct {
  id: string;
  title: string;
  productSlug: string;
}

interface TourDetailsData {
  data: {
    products: TourProduct[];
  }
}

const HotelDetailsComponent: React.FC<HotelDetailsProps> = ({
  //slug,
  roomDetails = [],
  // latitude,
  // longitude,
  tourQuery,
  // hotelId,
  // destinationCode,
  //hasWhyThisResort,
  amenities = []
}) => {
  // const [hotelDetails, setHotelDetails] = useState<HotelDetailsData | null>(null);
  const [tourDetails, setTourDetails] = useState<TourDetailsData | null>(null);
  const [selectedTourDetail, setSelectedTourDetail] = useState<any>(null);
  const [error, setError] = useState<string>('');
  const [activeTab, setActiveTab] = useState<string>('overview');
  const [openTourSlug, setOpenTourSlug] = useState<string | null>(null);
  //const [currentPhotoIndex, setCurrentPhotoIndex] = useState<number>(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  // const [viewMore, setViewMore] = useState(false);
  const [viewMoreFacility, setViewMoreFacility] = useState(
    amenities.map(() => false)
  );
  // const [propertyDetails, setPropertyDetails] = useState<PropertyDetails | null>(null);
  // const [currentPhotoIndex, setCurrentPhotoIndex] = useState(0);
  // const photosToShow = 3; // Number of photos to show at a time
  //const hasFetchedDetails = useRef(false);



  const [openSections, setOpenSections] = useState<{ [key: string]: boolean }>({
    overview: true,
    // 'room-details': false,
    tours: false,
    facilities: false,
    map: false,
  });

  const iconMap: Record<string, string> = {
    General: "/icons/general.svg",
    Rooms: "/icons/rooms.svg",
    Meals: "/icons/meals.svg",
    Internet: "/icons/internet.svg",
    Recreation: "/icons/recreation.svg",
    Parking: "/icons/parking.svg",
    Business: "/icons/business.svg",
    Sports: "/icons/sports.svg",
    Pets: "/icons/pets.svg",
    Kids: "/icons/kids.svg",
    Accessibility: "/icons/accessibility.svg",
    Transfer: "/icons/transfer.svg",
    "Health and Safety Measures": "/icons/health.svg",
    "Services and amenities": "/icons/services-and-amenities.svg",
    "Languages Spoken": "/icons/languages-spoken.svg",
    "Tourist services": "/icons/tourist-services.svg",
    "Pool and beach": "/icons/pool-and-beach.svg",
    "Beauty and wellness": "/icons/beauty-and-wellness.svg",
  };

  const toggleSection = (section: string) => {
    if (isMobile) {
      setOpenSections((prev) => ({ ...prev, [section]: !prev[section] }));
    } else {
      setActiveTab(section);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Set the initial value

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // useEffect(() => {
  //   if (!hasFetchedDetails.current && destinationCode && hotelId) {
  //     hasFetchedDetails.current = true;
  //     getHotelDetails();
  //   }
  // }, [destinationCode, hotelId]);

  useEffect(() => {
    loadTourDetails();
  }, [tourQuery]);

  // const getHotelDetails = async () => {
  //   try {
  //     const data = await fetchPropertyDetails(destinationCode, hotelId);
  //     setPropertyDetails(data as PropertyDetails);
  //   } catch (error: any) {
  //     setError(error.message);
  //   }
  // };

  const loadTourDetails = async () => {
    try {
      const data = await fetchTourDetails(tourQuery);
      setTourDetails(data as TourDetailsData);
    } catch (error: any) {
      setError(error.message);
    }
  };

  const handleFetchSpecificTourDetail = async (slug: string) => {
    if (slug === openTourSlug) {
      setSelectedTourDetail(null);
      setOpenTourSlug(null);
      return;
    }

    try {
      const data = await fetchSpecificTourDetail(slug);
      setSelectedTourDetail(data.data);
      setOpenTourSlug(slug);
    } catch (error: any) {
      setError(error.message);
    }
  };

  if (error) {
    return <div>Error: {error}</div>;
  }

  // if (!propertyDetails) {
  //   return <Loader />;
  // }

  // const getCountryByTourQuery = (tourQuery: string): Country | undefined => {
  //   const processedData = processData();
  //   for (const continent of processedData) {
  //     const country = continent.countries.find((country: Country) => country.name.toLowerCase() === tourQuery.toLowerCase());
  //     if (country) {
  //       return country;
  //     }
  //   }
  //   return undefined;
  // };

  // const country = getCountryByTourQuery(tourQuery);

  const renderTabContent = (tabName: string) => {
    switch (tabName) {
      case 'overview':
        return (
          <div>
            {/* Mobile Version */}
            {/* Mobile Version */}
            <div id="Overview" className="md:hidden py-2 space-y-6">
                {roomDetails.map((detail, index) => (
                  <div
                    key={index}
                    className="p-4 rounded-xl border border-gray-200 shadow-sm space-y-3 mb-4"
                  >
                    <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                      <div className="w-1 h-5 bg-halo-pink rounded-sm" />
                      <h3 className="text-lg font-semibold text-gray-900">{detail.title}</h3>
                    </div>
                    {detail.paragraphs.map((paragraph, pIndex) => (
                      <p
                        key={pIndex}
                        className="text-sm text-gray-700 leading-relaxed"
                        dangerouslySetInnerHTML={{ __html: paragraph }}
                      />
                    ))}
                  </div>
                ))}
            </div>

            {/* Desktop Version */}
            <div
              id="Overview"
              className="hidden md:block pt-2 space-y-8"
            >
              <ReadMoreLines desktopMaxRows={3}>
                {roomDetails.map((detail, index) => (
                  <div key={index} className="p-4 rounded-xl border border-gray-200 shadow-sm space-y-3 mb-4">
                    <div className="flex items-center gap-2 border-b border-gray-200 pb-2">
                      <div className="w-1 h-5 bg-halo-pink rounded-sm" />
                      <h3 className="text-lg md:text-xl font-semibold text-gray-800">
                        {detail.title}
                      </h3>
                    </div>

                    {detail.paragraphs.map((paragraph, pIndex) => (
                      <p
                        key={pIndex}
                        className="text-sm md:text-base text-gray-700 leading-relaxed"
                        dangerouslySetInnerHTML={{ __html: paragraph }}
                      />
                    ))}
                  </div>
                ))}
              </ReadMoreLines>
            </div>
          </div>

        );

      case 'things to do':
        return (
          <div id="tours">
            {tourDetails ? (
              <div className="scrollbar-initial bg-white shadow rounded-lg" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                <ul className="divide-y divide-gray-200">
                  {tourDetails.data.products.slice(0, 5).map((product) => (
                    <li key={product.id} className="py-4 px-4 hover:bg-gray-100 transition-colors">
                      <button
                        onClick={() => handleFetchSpecificTourDetail(product.productSlug)}
                        className="text-left w-full text-gray-800 flex justify-between items-center"
                      >
                        <span className="font-medium">{product.title}</span>
                        <span className="text-md" style={{ color: openTourSlug === product.productSlug ? '#dc0069' : '#000000' }}>
                          {openTourSlug === product.productSlug ? '⮝' : '⮟'}
                        </span>
                      </button>
                      {selectedTourDetail && openTourSlug === product.productSlug && (
                        <div className="mt-3 bg-gray-50 rounded-lg p-4 shadow-md">
                          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                            <img className="rounded-lg object-cover" src={selectedTourDetail.photos[0]?.medium} alt={selectedTourDetail.name} />
                            <img className="rounded-lg object-cover" src={selectedTourDetail.photos[1]?.medium} alt={selectedTourDetail.name} />
                            <img className="rounded-lg object-cover" src={selectedTourDetail.photos[2]?.medium} alt={selectedTourDetail.name} />
                          </div>
                          <p className="mt-4 text-gray-700">{selectedTourDetail.description}</p>
                        </div>
                      )}
                    </li>
                  ))}
                </ul>
              </div>
            ) : (
              <Loader />
            )}
          </div>
        );
      case 'facilities':
        return (
          <div id="facilities" className="pt-2"><div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {amenities.map((group, groupIndex) => {
              const showAll = viewMoreFacility[groupIndex]; // Optional: per-group control
              const visibleAmenities = showAll ? group.amenities : group.amenities.slice(0, 5);

              return (
                <div key={groupIndex} className='bg-white rounded-lg shadow p-4 border border-gray-200'>
                  <h3 className="flex items-center gap-2 text-lg font-semibold text-gray-800 mb-3">
                    <div className="w-6 h-6 flex items-center justify-center bg-gray-100 rounded-md overflow-hidden">
                      <img
                        src={iconMap[group.group_name] || "/icons/default.svg"}
                        alt={`${group.group_name} icon`}
                        className="w-4 h-4 object-contain"
                        onError={(e) => {
                          e.currentTarget.onerror = null;
                          e.currentTarget.src = "/icons/default.svg";
                        }}
                      />
                    </div>
                    <span>{group.group_name}</span>
                  </h3>
                  <ul className="space-y-2 text-sm text-gray-700 pl-2">
                    {visibleAmenities.map((amenity, index) => (
                      <li key={index} className="flex items-start gap-2">
                        <div className="mt-1.5 w-1.5 h-1.5 bg-pink-500 rounded-full flex-shrink-0" />
                        <div>
                          {amenity}
                          {group.non_free_amenities?.includes(amenity) && (
                            <span className="ml-2 text-xs bg-yellow-100 text-yellow-800 px-2 py-0.5 rounded font-medium">
                              charged separately
                            </span>
                          )}
                        </div>
                      </li>
                    ))}
                  </ul>


                  {group.amenities.length > 5 && (
                    <button
                      onClick={() => {
                        const updated = [...viewMoreFacility];
                        updated[groupIndex] = !updated[groupIndex];
                        setViewMoreFacility(updated);
                      }}
                      className="mt-3 inline-flex items-center gap-1 text-blue-600 hover:text-blue-800 text-sm font-medium transition-colors pl-2"
                    >
                      {showAll ? 'View Less' : 'View More'}
                      <svg
                        className={`w-4 h-4 transition-transform duration-200 ${showAll ? 'rotate-180' : ''
                          }`}
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        viewBox="0 0 24 24"
                      >
                        <path d="M19 9l-7 7-7-7" />
                      </svg>
                    </button>
                  )}
                </div>
              );
            })}
          </div>
          </div>

        );
      // case 'map':
      //   return (
      //     <div>
      //       <div className="map-container" style={{ height: '500px', width: '100%' }}>
      //         <GoogleMapComponent
      //           apiKey="AIzaSyD3BQK4fqJwhNVoFZyk6EB1whUD-3NehqI"
      //           latitude={parseFloat(latitude)}
      //           longitude={parseFloat(longitude)}
      //           zoom={17}
      //         />
      //       </div>
      //     </div>
      //   );
      default:
        return null;
    }
  };

  return (
    <>
      <div className={`md:flex md:gap-x-36 md:w-[800px] 2xl:w-[1000px] hidden md:block -mt-[9.5rem]`}>
        <div className="container py-6 px-4 md:px-1 2xl:flex-[4_4_0%] md:flex-[3_3_0%]">
          <div className="flex flex-col md:flex-row md:space-x-5 mb-4">
            {['overview', 'things to do', 'facilities'].map((tabName) => (
              <div key={tabName} className="mb-2 md:mb-0">
                <button
                  className={`w-full text-left text-[22px] font-semibold ${activeTab === tabName ? 'md:border-b-2 md:border-halo-pink' : ''}`}
                  onClick={() => toggleSection(tabName)}
                >
                  {tabName.charAt(0).toUpperCase() + tabName.slice(1).replace(/-/g, ' ')}
                  <span className="float-right md:hidden text-md">
                    {openSections[tabName] ? '−' : '+'}
                  </span>
                </button>
                {isMobile && openSections[tabName] && (
                  <div className="pt-4 pb-2 border-t border-b border-gray-200">
                    {renderTabContent(tabName)}
                  </div>
                )}
              </div>
            ))}
          </div>
          {!isMobile && renderTabContent(activeTab)}
        </div>
      </div>
      <div className='md:flex md:gap-x-36 md:w-[800px] 2xl:w-[1000px] md:-mt-52 md:hidden'>
        <div className="container py-6 px-4 md:px-1 2xl:flex-[4_4_0%] md:flex-[3_3_0%]">
          <div className="flex flex-col md:flex-row md:space-x-5 mb-4">
            {['overview', 'things to do', 'facilities'].map((tabName) => (
              <div key={tabName} className="mb-2 md:mb-0">
                <button
                  className={`w-full text-left text-[20px] font-medium flex justify-between items-center p-3 md:p-4 border border-gray-300 rounded-lg shadow-sm transition-all duration-300 ${activeTab === tabName
                    ? 'bg-white text-black hover:bg-halo-pink-bg hover:text-halo-pink'
                    : 'bg-white text-black hover:bg-halo-pink-bg hover:text-halo-pink'
                    }`}
                  onClick={() => toggleSection(tabName)}
                >
                  {tabName.charAt(0).toUpperCase() + tabName.slice(1).replace(/-/g, ' ')}
                  <span className="text-lg font-semibold">
                    {openSections[tabName] ? '−' : '⌵'}
                  </span>
                </button>
                {isMobile && openSections[tabName] && (
                  <div className="pt-4 pb-2 border-t border-b border-gray-200 transition-all duration-300">
                    {renderTabContent(tabName)}
                  </div>
                )}
              </div>
            ))}
          </div>
          {!isMobile && renderTabContent(activeTab)}
        </div>
      </div>
    </>
  );
};

export default HotelDetailsComponent;
